/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Deep_ResearchInputs */

const en_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep company research`)
};

const de_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiefgehende Unternehmensrecherche`)
};

const fr_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche approfondie d'entreprise`)
};

const es_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investigación profunda de empresas`)
};

const it_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca approfondita sull'azienda`)
};

const nl_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diepgaande bedrijfsanalyse`)
};

const pl_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Głębokie badanie firm`)
};

const fi_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syvä yritystutkimus`)
};

const da_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dybdeanalyse af firmaer`)
};

const sv_pricing_feature_deep_research = /** @type {(inputs: Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Djup företagsforskning`)
};

/**
* | output |
* | --- |
* | "Deep company research" |
*
* @param {Pricing_Feature_Deep_ResearchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_deep_research = /** @type {((inputs?: Pricing_Feature_Deep_ResearchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Deep_ResearchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_deep_research(inputs)
	if (locale === "fr") return fr_pricing_feature_deep_research(inputs)
	if (locale === "es") return es_pricing_feature_deep_research(inputs)
	if (locale === "it") return it_pricing_feature_deep_research(inputs)
	if (locale === "nl") return nl_pricing_feature_deep_research(inputs)
	if (locale === "pl") return pl_pricing_feature_deep_research(inputs)
	if (locale === "fi") return fi_pricing_feature_deep_research(inputs)
	if (locale === "da") return da_pricing_feature_deep_research(inputs)
	if (locale === "sv") return sv_pricing_feature_deep_research(inputs)
	return en_pricing_feature_deep_research(inputs)
});